import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';

import { CivilCase} from '../civil-case';

@Component({
  selector: 'app-civil-search-results-pleads-grid',
  templateUrl: './civil-search-results-pleads-grid.component.html',
  styleUrls: ['./civil-search-results-pleads-grid.component.less']
})
export class CivilSearchResultsPleadsGridComponent implements OnInit {
   @Input() case: CivilCase;
   @Input() gridType: string;  // table or ag-grid
   @Input() caseRowIndex: number;
   @Input() maxDisplayRows: number;
   @Input() bgHighlighted: boolean;
   @Input() rowBeingShown: boolean;
   @Input() rowToBeHidden = false;
   @Output() onPleadingClosed = new EventEmitter<number>();

   pleadingTableColumnHeaders: any[];    // using table
   pleadingTableColumnWidths: any[];
   pleadingTableDataList: any[];

   constructor() {
   }

   ngOnInit() {
      if (this.gridType === null || this.gridType === undefined) {
          this.gridType = 'table';
      }

     // set table list data
     this.pleadingTableDataList     = this.case.getPleadingsIssuesDisplayList();

     // set the table headers and column widths
      this.pleadingTableColumnWidths = ['18%', '27%', '55%' ];
      this.pleadingTableColumnHeaders = this.getPleadingTableColumnHeaders();

      // reset the header column widths (header column should have the same widths)
     let colCnt: number = this.pleadingTableColumnWidths.length;
     for (let idx = 0; idx <  colCnt ; idx++ ) {
        this.pleadingTableColumnHeaders[idx].headerWidth = this.pleadingTableColumnWidths[idx];
     }
   }

   scrollbarShouldBeShown(): boolean {
     return this.pleadingTableDataList.length > this.maxDisplayRows;
   }

   /**
    * check on the transition end event and emit the onPleadingClosed event
    * @param event
    */
   @HostListener('window:transitionend', ['$event'])
   onTransitionEnd($event) {
      if (this.rowToBeHidden === true) {
          this.onPleadingClosed.emit(this.caseRowIndex);
          this.rowToBeHidden = false;
      }
   }

   /**
    *  get the display grid header list (in ag-grid format)
    */
   getPleadingTableColumnHeaders() {
      let cloumnHeaders = [
        { headerName: 'Filing Clock Date',
          field: 'pleadingClockDate',
          vcode: 'V004.a',
          vcodeDesc: '',
          width: 100,
          headerWidth: '18%',
          popoverTitle: 'Filing Clock Date',
          popoverShow: true,
          popoverContent: 'This date is the date the document initiating the case was clocked (stamped) in the clerk’s office.',
          popoverTemplate: ''
        },
        { headerName: 'Filing',
          field: 'pleadingType',
          vcode: 'V051',
          vcodeDesc: '',
          width: 100,
          headerWidth: '27%',
          popoverTitle: 'Filing',
          popoverShow: true,
          popoverContent: 'Indicates what type of action was filed. For example, Complaint, Motion, Amended Pleading, Confession of Judgment, Consent Order. ',
          popoverTemplate: ''
        },
        { headerName: 'Issue',
          field: 'pleadingIssueType',
          vcode: 'V005.a',
          vocdeDesc: '',
          width: 100,
          headerWidth: '55%',
          popoverTitle: 'Issue',
          popoverShow: true,
          popoverContent: 'Issues are specific claims for relief sought by the filing party. For example, Divorce, Money Owed, Default Judgment.',
          popoverTemplate: ''
        }
      ];

      return cloumnHeaders;
   }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-search-results-pleads-grid/civil-search-results-pleads-grid.component.ts